import React from "react";
import AmbassadorForm from "features/sections/ambassador/components/ambassador-form/AmbassadorForm";
import "./style.scss";
import { hexToRgbA } from "shared/helpers/ColorsHelper";
import cn from "classnames";

const Ambassador = (props) => {
  const {
    id,
    primary_color,
    secondary_color,
    background_img,
    header,
    form_placement = "right",
    default_campaign_id,
  } = props.ambassador;

  return (
    <div
      className="ambassador-root root-background-img"
      style={{ backgroundImage: `url(${background_img.url})`, width: "100%" }}>
      <div
        className={cn("layer", form_placement)}
        style={{
          backgroundColor: hexToRgbA(primary_color, "0.6"),
        }}>
        {header && <h1 className="header"> {header} </h1>}
        <AmbassadorForm
          ambassadorId={id}
          primaryColor={primary_color}
          secondaryColor={secondary_color}
          defaultCampaignId={default_campaign_id}
        />
      </div>
    </div>
  );
};

export default Ambassador;
